import { render, staticRenderFns } from "./EmailEmptyResults.vue?vue&type=template&id=b05fa568"
import script from "./EmailEmptyResults.vue?vue&type=script&lang=js"
export * from "./EmailEmptyResults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports